/**
 * Pure maths for positional audio (used by sound effects in M0+ and by
 * proximity voice in M3; see docs/50). Distances are in tiles.
 */
/** Default for voice: full volume within 2 tiles, silent past 12 tiles. */
export const VOICE_PROXIMITY = { refDistance: 2, maxDistance: 12, rolloff: 1.6 };
/** Gain in [0, 1] for a source at `dist` tiles from the listener. */
export function proximityGain(dist, p) {
    if (dist <= p.refDistance)
        return 1;
    if (dist >= p.maxDistance)
        return 0;
    const u = (dist - p.refDistance) / (p.maxDistance - p.refDistance);
    return Math.pow(1 - u, p.rolloff);
}
/**
 * Stereo pan in [-1, 1] from the source's horizontal SCREEN offset relative
 * to the listener (iso screen x, not tile x), so sound follows what you see.
 */
export function screenPan(dxScreenPx, halfWidthPx) {
    if (halfWidthPx <= 0)
        return 0;
    const p = dxScreenPx / halfWidthPx;
    return p < -1 ? -1 : p > 1 ? 1 : p;
}
